"use strict";
import Auth from "../util/auth";
import { Flash } from "../components/flash_messages";
import { History } from "react-router";
import WaitingSpinner from "./waiting_spinner";
var Logout = React.createClass({
  mixins: [History],
  // LIFECYCLE
  getInitialState: function() {
    return {
      loading: true
    };
  },
  componentWillMount: function() {
    this.logoutAndRedirect();
  },
  componentWillReceiveProps: function() {
    this.logoutAndRedirect();
  },
  // STATE
  logoutAndRedirect: function() {
    return Auth.logout().then(() => {
      Flash.success("Logged out successfully!");
      window.location = this.afterLogoutDestination();
    });
  },
  afterLogoutDestination: function() {
    const oktaConfig = JSON.parse(window.oktaConfig);
    const user = Auth.getCurrentUser();
    let destination = "/app/login";
    if (user && user["okta_enabled?"]) {
      destination = oktaConfig.logoutRedirectUri;
    }
    return destination;
  },
  // RENDERING
  render: function() {
    return /* @__PURE__ */ React.createElement(WaitingSpinner, { when: this.state.loading }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-6 small-centered columns" }, /* @__PURE__ */ React.createElement("div", { className: "panel callout radius" }, "Logging out\u2026"))));
  }
});
export default Logout;
